
export const Filters = {

	data() {
		return {
			filtersRef: undefined,
			paginationRef: undefined,
			removeFiltersBeforeDestroyed: false,
			removePaginationBeforeDestroyed: false,
		};
	},

	beforeDestroy() {
		if (!this.removeFiltersBeforeDestroyed && this.filtersRef) {
			this.$store.commit("dataTableFilters", {
				component: this.$options.name,
				filters: this.filtersRef
			});
		}
		if (!this.removePaginationBeforeDestroyed && this.paginationRef) {
			this.$store.commit("dataTablePagination", {
				component: this.$options.name,
				pagination: this.paginationRef
			});
		}
	},

	methods: {
		retrieveFilters(filtersRef, removeBeforeDestroyed = false) {
			this.removeFiltersBeforeDestroyed = removeBeforeDestroyed;
			let componentFilters = this.$store.state.dataTableFilters[this.$options.name];
			if (componentFilters) {
				this.filtersRef = componentFilters;
			} else {
				this.filtersRef = filtersRef;
			}
			return this.filtersRef;
		},

		retrievePagination(paginationRef, removeBeforeDestroyed = false) {
			this.removePaginationBeforeDestroyed = removeBeforeDestroyed;
			let componentPagination = this.$store.state.dataTablePagination[this.$options.name];
			if (componentPagination) {
				this.paginationRef = componentPagination;
			} else {
				this.paginationRef = paginationRef;
			}
			return this.paginationRef;
		}
	}
};
